/** @jsx jsx */
import { jsx, css, useTheme } from "@emotion/react";
import { isUndefined, omit, omitBy } from "lodash/fp";
import { Fragment } from "react";

import {
  useThemeProps,
  Button,
  Heading,
  TypographyBlock,
  Section,
  Card,
  parseStyle,
  CardContent,
  Stack,
  InlineList,
  Icon,
} from "../wsui/base";

FeatureBillboardModule.wsuiConfig = {
  hasCaption: true,
};

export default function FeatureBillboardModule(props) {
  const theme = useTheme();
  props = omitBy(isUndefined, props);
  props = useThemeProps({
    props,
    name: "MunicipioFeatureBillboardModule",
  });
  let {
    content,
    links,
    image,
    imageAspectRatio = 16 / 9,
    imagePlacement = "left",
    title,
    style,
    titleVariant = "caption",
    horizontalContentMaxWidth = "100%",
    mediaColspan = 6,
    buttonProps,
    contentGap = 5,
    contentElementMapping = { p: "description" },
    beforeTitle = null,
    cardContentProps = {},
    icon,
    align,
    ...restProps
  } = omit(["color", "buttonMarginTop", "headingVariant"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const inlineListAlign =
    contentAlign === "left"
      ? "start"
      : contentAlign === "right"
        ? "end"
        : contentAlign === "center"
          ? "center"
          : undefined;

  let MaybeSection = title ? Section : Fragment;

  return (
    <Card
      color="transparent"
      image={image}
      mediaColspan={mediaColspan}
      mediaAspectRatio={imageAspectRatio}
      mirrored={imagePlacement === "right"}
      css={css`
        ${parseStyle(style, theme)}
      `}
      horizontalContentMaxWidth={horizontalContentMaxWidth}
      {...restProps}
    >
      <CardContent {...cardContentProps}>
        <span
          css={css`
            display: flex;
            gap: 1rem;
            @media (max-width: 640px) {
              flex-direction: column;
            }
          `}
        >
          {icon && <Icon name={icon} size={20} css={{ flex: "none" }} />}
          <Stack spacing={contentGap}>
            {beforeTitle}
            {!!title && <Heading variant={titleVariant} align={contentAlign}>{title}</Heading>}
            <MaybeSection>
              <TypographyBlock
                maxBlockMargin={contentGap}
                elementMapping={contentElementMapping}
                align={contentAlign}
              >
                {content}
              </TypographyBlock>
              {!!links?.length && (
                <InlineList align={inlineListAlign}>
                  {links.map(({ link, variant = "primary" }, index) => (
                    <Button
                      key={index}
                      {...link}
                      variant={variant}
                      {...buttonProps}
                    />
                  ))}
                </InlineList>
              )}
            </MaybeSection>
          </Stack>
        </span>
      </CardContent>
    </Card>
  );
}
